import {TutorialSvcFactory} from '../services/TutorialSvc';
import {TranslateSvc} from '../services/TranslateSvc';
import {Utils} from '../underscore-extensions';

class TutorialVideoCtrl {
    userName: string;
    userAvatar: string;
    title: string;
    description: string;
    videoId: string;
    videoUrl: string;
    duration: string;
    width: number  = 720;
    height: number = 438;

    constructor($sce: ng.ISCEService,
                TutorialSvcFactory: TutorialSvcFactory,
                TranslateSvc: TranslateSvc) {
        const tutorialSvc   = new TutorialSvcFactory();
        const videoData     = tutorialSvc.getCurrentVideo();
        const youtubeParams = Utils.toParams({
            autoplay: 1,
            hl: TranslateSvc.currentLang(),
            cc_load_policy: 1,
            fs: 1
        });

        if (videoData.author) {
            this.userName   = videoData.author.name || videoData.channelTitle;
            this.userAvatar = videoData.author.avatar;
        }

        this.title       = videoData.title;
        this.title       = videoData.title.replace(/\|[\s\S]*/, '').trim();
        this.description = videoData.description.replace(/Discover our blog[\s\S]*|Read our blog[\s\S]*|Visit[\s\S]*|Not a member[\s\S]*/, '').trim();
        this.duration    = tutorialSvc.calcTime(videoData.duration);
        this.videoId     = videoData.id;
        const videoUrl   = `https://www.youtube.com/embed/${this.videoId}?${youtubeParams}`;
        this.videoUrl    = $sce.trustAsResourceUrl(videoUrl);
    }
}

angular.module('animatronApp.tutorial')
    .component('tutorialVideo', {
        controller: TutorialVideoCtrl,
        controllerAs: 'TutorialVideoCtrl',
        templateUrl: require('tutorials/tutorial-video.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/tutorialVideoDirective.ts